import Fuse from "fuse.js";

export default function CreateFuzzySearchFilter<T>(
  options: T[],
  getOptionSearchText: (option: T) => string
) {
  //Create the fuse object for the list of options
  const fuse = new Fuse(options, {
    keys: [{ name: "name", getFn: getOptionSearchText }],
    threshold: 0.3,
  });

  //Return a function that MUI AutoComplete can pass search text
  //to and return a ranked list of matching options.
  return (state: { inputValue: string }) => {
    //Get the search text
    const searchText = state?.inputValue ?? "";

    //Return all options if no search text
    if (!searchText.length) return options;

    //Run the fuzzy search and return an array of original option objects
    return fuse.search(searchText).map((r) => r.item);
  };
}
